import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../context/I18nContext";
import { mailto } from "../lib/api";
import Seo from "../components/Seo";

export default function Contact() {
  const { t, lang } = useI18n();

  return (
    <div data-testid="page-contact" className="stoel-container pt-12 md:pt-20 pb-32">
      <Seo
        path="/contact"
        titleNl="Contact"
        titleEn="Contact"
        descNl="Voor projectaanvragen, samenwerking of een eerste gesprek — schrijf direct naar info@destoel.com."
        descEn="For project enquiries, collaboration or a first conversation — write directly to info@destoel.com."
      />
      <header className="mb-16 max-w-3xl">
        <div className="stoel-eyebrow mb-4">— {t.nav.contact}</div>
        <h1 className="stoel-display text-5xl md:text-6xl lg:text-7xl">{t.contact.title}</h1>
        <p className="mt-6 text-lg text-stoel-inkSoft leading-relaxed">
          {t.contact.intro}
        </p>
      </header>

      <div className="border border-stoel-line">
        <ContactCard
          testid="contact-info"
          eyebrow={t.contact.general}
          email="info@destoel.com"
          subject={t.contact.mailtoSubject}
          subtitle={lang === "nl" ? "Voor projecten, samenwerking en pers — wij reageren persoonlijk." : "For projects, collaboration and press — we reply personally."}
        />
      </div>

      <p className="mt-12 text-sm text-stoel-inkSoft max-w-xl leading-relaxed">
        {lang === "nl"
          ? "We werken op afspraak — geen showroom, geen vrije inloop. Schrijf vooraf zodat we voldoende tijd voor uw vraag inruimen."
          : "We work by appointment — no showroom, no walk-ins. Write ahead so we can carve out the time your question deserves."}
      </p>
    </div>
  );
}

function ContactCard({ eyebrow, email, subject, subtitle, testid }) {
  return (
    <a
      href={mailto(subject, email)}
      data-testid={testid}
      className="group block bg-stoel-paper p-10 md:p-14 transition-colors hover:bg-stoel-paperDeep"
    >
      <div className="stoel-eyebrow mb-4">— {eyebrow}</div>
      <div className="text-2xl md:text-3xl lg:text-4xl font-light tracking-tight text-stoel-ink flex items-baseline gap-3 break-all">
        {email}
        <ArrowUpRight
          size={20}
          className="text-stoel-terracotta translate-x-0 group-hover:translate-x-1 transition-transform shrink-0"
        />
      </div>
      <p className="mt-4 text-sm text-stoel-inkSoft max-w-sm leading-relaxed">
        {subtitle}
      </p>
    </a>
  );
}
